import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 379B9D93-434B-46E7-9ABC-CAFAB694B209
 * name map-marker
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapMarkerIcon = createSvgIcon(<><path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" /></>, 'MapMarkerIcon');
export default MapMarkerIcon